export default {
	utilities: {
		title: "Utilities",
		hint: "Hand-written TypeScript. Anything exported here is callable from the code of any Custom Action as UTILITIES.<name>.",
		privateNotice:
			"Utilities are project-private. They are never shared through a dependency, even though the file travels inside the package.",
		saved: "Utilities saved.",
		resetAction: "Reset",
		resetConfirm: "Discard the current utilities and restore the starting file?",
		reset: "Utilities reset to the starting file.",
	},
};
